import {Expose} from 'class-transformer';

export class UserMoviePictureApiModel {
  @Expose()
  url1: string;

  @Expose()
  url2: string;
}
